import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <motion.header initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-cream-50/85 backdrop-blur-md border-b border-cream-300/50' : 'bg-transparent'}`} data-id="element-119">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between" data-id="element-120">
        <a href="#" className="font-serif text-2xl text-ink leading-none" data-id="element-121">
          Wonder <span className="italic text-lilac-400" data-id="element-122">of</span> Life
        </a>

        <nav className="hidden lg:flex items-center gap-10" data-id="element-123">
          {/* Links removed as requested */}
        </nav>

        <a href="https://calendly.com/wonderoflifewellness1/30min" target="_blank" rel="noopener noreferrer" className="hidden lg:inline-flex items-center px-6 py-2.5 rounded-full border border-ink/20 text-[11px] uppercase tracking-luxe text-ink hover:bg-ink hover:text-cream-50 transition-all" data-id="element-124">
          Book a Visit
        </a>

        <button aria-label="Open menu" onClick={() => setOpen(!open)} className="lg:hidden text-ink" data-id="element-125">
          {open ? <XIcon size={22} data-id="element-126" /> : <MenuIcon size={22} data-id="element-127" />}
        </button>
      </div>

      {open && <div className="lg:hidden bg-cream-50/95 backdrop-blur-md border-t border-cream-300/60 px-6 py-6 flex flex-col gap-5" data-id="element-128">
          <a href="https://calendly.com/wonderoflifewellness1/30min" target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className="mt-2 inline-flex justify-center px-6 py-3 rounded-full border border-ink/20 text-xs uppercase tracking-luxe" data-id="element-129">
            Book a Visit
          </a>
        </div>}
    </motion.header>;
}